module.exports = "/_next/static/images/PredictiveAI@2x-f2b0005c27e62e319c4c10d4f4b46730.webp";